
import React from "react";
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "@/hooks/use-mobile";

export const AttendanceTableHeader: React.FC = () => {
  const { t } = useTranslation(["common"]);
  const isMobile = useIsMobile();
  
  return (
    <TableHeader>
      <TableRow>
        <TableHead className={isMobile ? "px-1 py-1 text-[9px]" : ""}>
          {t("classes", { ns: "common" })}
        </TableHead>
        <TableHead className={isMobile ? "px-1 py-1 text-[9px] whitespace-nowrap" : ""}>
          {t("date", { ns: "common" })}
        </TableHead>
        <TableHead className={isMobile ? "px-1 py-1 text-[9px]" : ""}>
          {t("attendance", { ns: "common" })}
        </TableHead>
        <TableHead className={isMobile ? "px-1 py-1 text-[9px]" : ""}>
          {t("status", { ns: "common" })}
        </TableHead>
      </TableRow>
    </TableHeader>
  );
};
